// src/components/ProjectCard.js
import React from 'react';


const ProjectCard = ({ title, imgSrc, link }) => {
  return (
    <div className="project-card">
      <img src={imgSrc} alt={title} className="project-img"/>
      <h3>{title}</h3>
      <a href={link} target="_blank" rel="noopener noreferrer">Visit Site</a>
    </div>
  );
};

export default ProjectCard;
